export default __webpack_public_path__ + "static/media/July2009.f2ce7b33.png";